import React from 'react';

import type { TConstantPaths } from '@hooks';

import { WhatWeDoContainer } from './styles';
import { ConstLink } from '../const-link';
import { StaticImage } from 'gatsby-plugin-image';

type TService = {
  icon: React.ReactElement<any, any>;
  title: string;
  description: string;
  link: TConstantPaths;
};

const WhatWeDo = () => {
  const services: TService[] = [
    // First Row
    {
      icon: (
        <StaticImage
          src="../../images/icons/motor-vehicle-accidents.png"
          alt="Motor Vehicle Accidents"
          height={76}
        />
      ),
      title: 'Motor Vehicle\nAccidents',
      description:
        "If you were injured in a motor vehicle and it wasn't your fault you could be entitled to compensation, read more about it here.",
      link: '/car-accidents',
    },
    {
      icon: (
        <StaticImage
          src="../../images/icons/tpd-super.png"
          alt="TPD & Superannuation Claims"
          height={76}
        />
      ),
      title: 'TPD & Superannuation\nClaims',
      description:
        'Even if you are at fault, you may have significant entitlements under your superannuation policy. We can check this for free! Find out more here.',
      link: '/tpd-and-superannuation-claims',
    },
    {
      icon: (
        <StaticImage
          src="../../images/icons/medical.png"
          alt="Medical Negligence"
          height={76}
        />
      ),
      title: 'Medical\nNegligence',
      description:
        "If you've received medical care or treatment that didn't meet the expected standard of care and has caused you harm. Read more about it here.",
      link: '/medical-negligence',
    },
    {
      icon: (
        <StaticImage
          src="../../images/icons/workplace-accidents.png"
          alt="Workcover & Workplace Accidents"
          height={76}
        />
      ),
      title: 'Workcover &\n Workplace Accidents',
      description:
        'If you have been injured at work or suffered a work-related illness, you will be entitled to workers’ compensation to cover many different expenses. Read more about it here.',
      link: '/workcover-and-workplace-accidents',
    },
    // Second Row
    {
      icon: (
        <StaticImage
          src="../../images/icons/bicycle-accidents.png"
          alt="Bicycle Accidents"
          height={76}
        />
      ),
      title: 'Bicycle\nAccidents',
      description:
        "Car door opened in front of your bike, someone driving erratically, hit a pothole that shouldn't have been there... there are a lot of reasons you could have a compensation claim for your bicycle accident. Find out more here.",
      link: '/bicycle-accidents',
    },
    {
      icon: (
        <StaticImage
          src="../../images/icons/bus-taxi-rideshare-accidents.png"
          alt="Bus, Taxi and Rideshare Accidents"
          height={76}
        />
      ),
      title: 'Bus, Taxi and\nRideshare Accidents',
      description:
        'If you were injured in a bus, taxi or rideshare and have questions about compensation, read about it here.',
      link: '/public-transport-accidents',
    },
    {
      icon: (
        <StaticImage
          src="../../images/icons/pedestrian.png"
          alt="Pedestrian Accidents"
          height={76}
        />
      ),
      title: 'Pedestrian\nAccidents',
      description:
        "Walking across the street shouldn't be dangerous, but we've helped lots of clients who've been injured in this way. See more here.",
      link: '/pedestrian-accidents',
    },
    // Third row
    {
      icon: (
        <StaticImage
          src="../../images/icons/death-loss-of-dependency.png"
          alt="Wrongful Death & Loss of Dependency"
          height={76}
        />
      ),
      title: 'Wrongful Death &\nLoss of Dependency',
      description:
        'If you have questions about compensation for the loss of a partner or family member from an accident, you can read more about it here.',
      link: '/wrongful-death-loss-of-dependency',
    },
    {
      icon: (
        <StaticImage
          src="../../images/icons/motorbike.png"
          alt="Motorbike Accidents"
          height={76}
        />
      ),
      title: 'Motorbike\nAccidents',
      description:
        'Like cars and bicycles, motorbike accidents can be catastrophic. If you or someone you know has been involved in a motorbike accident you can find out how we can help here.',
      link: '/motor-bike-accidents',
    },
    {
      icon: (
        <StaticImage
          src="../../images/icons/truck.png"
          alt="Truck Accidents"
          height={76}
        />
      ),
      title: 'Truck\nAccidents',
      description:
        'If you were injured driving a truck or heavy vehicle and are unsure about truck accident compensation, you can read more about it here.',
      link: '/truck-accidents',
    },
    // Fourth row
    {
      icon: (
        <StaticImage
          src="../../images/icons/electric-skateboard.png"
          alt="Electric Skateboard Accidents"
          height={105}
        />
      ),
      title: 'Electric Skateboard\nAccidents',
      description:
        'If you were injured while riding an electric skateboard and are unsure about compensation, you can read more about it here.',
      link: '/electric-skateboard-accidents',
    },
  ];

  return (
    <WhatWeDoContainer className="what_we_do">
      <div className="what_we_do__content">
        <h2>What we do</h2>
        <hr />
        <div className="what_we_do__grid">
          {services.map(({ icon, title, description, link }) => (
            <div className="what_we_do__item" key={link}>
              <div>
                {icon}
                <h3>
                  <pre>{title}</pre>
                </h3>
                <p>{description}</p>
              </div>
              <ConstLink to={link}>Find out more</ConstLink>
            </div>
          ))}
        </div>
      </div>
    </WhatWeDoContainer>
  );
};

export { WhatWeDo };
